import { SvgIcon, SvgIconProps } from "@mui/material";

export const AdvancedTestIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        {...props}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_13062_29817)">
          <path
            d="M30.8583 14.5653C31.5413 23.4251 24.5499 30.9189 15.7503 30.9189C6.95069 30.9189 0.582031 24.1283 0.582031 15.7506C0.582031 11.0896 2.67143 6.91083 5.98635 4.13836C6.76988 3.43519 8.07575 2.67176 8.07575 2.67176C13.1787 -0.341803 19.7282 -0.100718 24.6503 3.47537"
            fill="#2962FF"
          />
          <path
            d="M30.8583 14.5653C31.5413 23.4252 24.5499 30.9189 15.7503 30.9189C6.95069 30.9189 0.582031 24.1283 0.582031 15.7506C0.582031 11.0896 2.67143 6.91083 5.98635 4.13836C6.76988 3.43519 8.07575 2.67176 8.07575 2.67176C13.1787 -0.341803 19.7282 -0.100718 24.6503 3.47537"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.877 12.978C28.1472 21.3557 19.8298 28.7088 11.8137 25.4742C11.0302 25.1929 9.80466 24.3893 9.80466 24.3893C7.05228 22.5008 5.24414 19.3265 5.24414 15.7304C5.24414 9.92423 9.9453 5.24316 15.7313 5.24316C18.7449 5.24316 21.4772 6.50886 23.3858 8.55808"
            fill="white"
          />
          <path
            d="M25.877 12.978C28.1472 21.3557 19.8298 28.7088 11.8137 25.4742C11.0302 25.1929 9.80466 24.3893 9.80466 24.3893C7.05228 22.5008 5.24414 19.3265 5.24414 15.7304C5.24414 9.92423 9.9453 5.24316 15.7313 5.24316C18.7449 5.24316 21.4772 6.50886 23.3858 8.55808"
            stroke="white"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.2108 28.1266L28.126 29.2115C27.3023 30.0352 27.1817 31.321 27.8045 32.2854C32.4253 39.2969 34.7357 40.4822 37.6086 37.6093C40.4816 34.7364 39.2962 32.426 32.2847 27.8052C31.3002 27.1623 30.0145 27.3029 29.2108 28.1266Z"
            fill="#2962FF"
            stroke="#2962FF"
            strokeWidth="0.93"
            strokeMiterlimit="10"
          />
          <path
            d="M30.3162 14.5856C34.1886 14.5856 37.3278 11.4464 37.3278 7.57405C37.3278 3.70168 34.1886 0.5625 30.3162 0.5625C26.4439 0.5625 23.3047 3.70168 23.3047 7.57405C23.3047 11.4464 26.4439 14.5856 30.3162 14.5856Z"
            fill="#2962FF"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.2498 5.82658H32.4663C32.2453 5.82658 32.0846 5.66586 32.0846 5.44486V4.66134C32.0846 4.01844 31.5622 3.49609 30.9193 3.49609H29.734C29.0911 3.49609 28.5688 4.01844 28.5688 4.66134V5.44486C28.5688 5.66586 28.408 5.82658 28.187 5.82658H27.4035C26.7606 5.82658 26.2383 6.34893 26.2383 6.99182V8.17716C26.2383 8.82005 26.7606 9.3424 27.4035 9.3424H28.187C28.408 9.3424 28.5688 9.50313 28.5688 9.72412V10.5076C28.5688 11.1505 29.0911 11.6729 29.734 11.6729H30.9193C31.5622 11.6729 32.0846 11.1505 32.0846 10.5076V9.72412C32.0846 9.50313 32.2453 9.3424 32.4663 9.3424H33.2498C33.8927 9.3424 34.4151 8.82005 34.4151 8.17716V6.99182C34.4151 6.34893 33.8927 5.82658 33.2498 5.82658Z"
            fill="white"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.5645 25.2334L29.9552 27.6242"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.6251 29.9552L25.2344 27.5645"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.74023 18.0817L9.5 16L10.4077 13.481C10.4077 13.481 10.5685 13.4007 10.5886 13.481L12.236 18.0817"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.26172 16.9365H11.7328"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5859 13.4199V18.0005"
            stroke="black"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.0721 18.0614C15.6703 18.0614 14.6055 18.0614 14.6055 18.0614C14.6055 18.0614 14.6055 16.3738 14.6055 15.7309V13.4004H16.052C18.8245 13.4004 18.7642 18.0212 16.0922 18.0614H16.0721Z"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.8301 13.4199L21.5177 18.0206C21.5177 18.0206 21.6985 18.1211 21.7186 18.0206L23.3258 13.44"
            stroke="#2962FF"
            strokeWidth="0.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
